import type { Typography } from '../../style/color';

const GreenTypography: Typography = {
  fontFamily: ['Roboto', 'sans-serif'].join(','),
};

export default GreenTypography;
